export const routeParamInfoItems = [
  {
    route: 'planyourvisit',
    routeParam: 'wheretostay',
    cat: 'ACCOMM',
    cla: '',
  },
  {
    route: 'planyourvisit',
    routeParam: 'touroperators',
    cat: 'TOUROPERATOR',
    cla: '',
  },
  {
    route: 'aboutus',
    routeParam: 'aboutseychelles',
    page: 'about-us',
  },
  {
    route: 'planyourvisit',
    routeParam: 'gettingaround',
    cla: 'BICYCLE,BOAT,CAR,DOMAIRSVC,EQUIP,MINBUSCOAC,YACHT,BUSSVC,COACHSVC,FERRYSVC,TAXI',
    bannerCat: 'getting-around',
  },
  {
    route: 'travelinfo',
    routeParam: 'travelinformation',
    page: 'travel-info',
  },
  {
    route: 'planyourvisit',
    routeParam: 'airlines',
    cat: 'TRANSPORT',
    cla: 'INTAIRSVC',
  },

  {
    route: 'planyourvisit',
    routeParam: 'generalservices',
    cat: 'GENSERVICE',
  },
  {
    route: 'planyourvisit',
    routeParam: 'informationservices',
    cat: 'INFO',
  },
  {
    route: 'planyourvisit',
    routeParam: 'rentals',
    cat: 'HIRE',
    cla: '',
    bannerCat: 'getting-around',
  },
  {
    route: 'planyourvisit',
    routeParam: 'ferries',
    cat: 'TRANSPORT',
    cla: 'FERRYSVC',
    bannerCat: 'getting-around',
  },
  {
    route: 'planyourvisit',
    routeParam: 'domesticflights',
    cat: 'TRANSPORT',
    cla: 'AIRSVC',
    bannerCat: 'getting-around',
  },
  {
    route: 'planyourvisit',
    routeParam: 'coachservices',
    cat: 'TRANSPORT',
    cla: 'COACHSVC',
    bannerCat: 'getting-around',
  },
  {
    route: 'planyourvisit',
    routeParam: 'buses',
    cat: 'TRANSPORT',
    cla: 'BUSSVC',
    bannerCat: 'getting-around',
  },
  {
    route: 'planyourvisit',
    routeParam: 'taxis',
    cat: 'TRANSPORT',
    cla: 'TAXI',
    bannerCat: 'getting-around',
  },

  {
    route: 'experience',
    routeParam: 'theislands',
    cat: 'DESTINFO',
    cla: 'ISLANDS',
    bannerCat: 'islands',
  },
  {
    route: 'experience',
    routeParam: 'activities',
    cat: 'TOUR',
    cla: '',
    bannerCat: 'activity',
  },
  {
    route: 'experience',
    routeParam: 'generalservices',
    cat: 'GENSERVICE',
    cla: '',
    bannerCat: '',
  },
  {
    route: 'experience',
    routeParam: 'beaches',
    cat: 'DESTINFO',
    cla: 'BEACHES',
    bannerCat: 'beaches',
  },
  {
    route: 'experience',
    routeParam: 'food-drinks',
    cat: 'RESTAURANT',
    cla: '',
  },
  {
    route: 'experience',
    routeParam: 'walksandtrails',
    cat: 'ATTRACTION',
    // cla: 'NATATTRACT',
    cla: '',
    tag: 'TAGWalks-Trails',
    bannerCat: 'walks-trails',
  },
  {
    route: 'experience',
    routeParam: 'attractions',
    cat: 'ATTRACTION',
    cla: '',
  },
  {
    route: 'experience',
    routeParam: 'events',
    cat: 'EVENT',
    cla: '',
  },

  {
    route: 'experience',
    routeParam: 'galleries',
    cat: 'ATTRACTION',
    cla: 'GALMUSECOL',
  },
  {
    route: 'experience',
    routeParam: 'parksandgardens',
    cat: 'ATTRACTION',
    cla: 'PKGDNCEM',
  },
  {
    route: 'experience',
    routeParam: 'entertainmentvenues',
    cat: 'ATTRACTION',
    cla: 'ENTERTAIN',
  },
  {
    route: 'experience',
    routeParam: 'historicalsites',
    cat: 'ATTRACTION',
    cla: 'HISTHERITG',
  },
  {
    route: 'experience',
    routeParam: 'landmarks',
    cat: 'ATTRACTION',
    cla: 'LMARKBLD',
  },
  {
    route: 'experience',
    routeParam: 'nationalparks',
    cat: 'ATTRACTION',
    cla: 'NATPARKRES',
  },
  {
    route: 'experience',
    routeParam: 'amusementparks',
    cat: 'ATTRACTION',
    cla: 'AMUSETHEME',
  },
  {
    route: 'experience',
    routeParam: 'nationalattraction',
    cat: 'ATTRACTION',
    cla: 'NATATTRACT',
  },
  {
    route: 'experience',
    routeParam: 'shoppingandmarkets',
    cat: 'ATTRACTION',
    cla: 'SHOPPING',
  },
  {
    route: 'experience',
    routeParam: 'spasandretreats',
    cat: 'ATTRACTION',
    cla: 'SPARETREAT',
  },
  {
    route: 'experience',
    routeParam: 'sportsandrecreation',
    cat: 'ATTRACTION',
    cla: 'SPORTREC',
  },
  {
    route: 'experience',
    routeParam: 'zoosandwildlifeparks',
    cat: 'ATTRACTION',
    cla: 'ZOOSNCAQU',
  },
];
